import * as React from "react"

const Favourite = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 18"
    style={{
      enableBackground: "new 0 0 20 18",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <title>Wishlist</title>
    <path
      d="M10.7 16.9c3.5-3.4 8.6-8.6 8.6-11.4 0-5-6.8-6.1-9.2-2.2C7.8-.6 1 .6 1 5.6 1 8.9 5.2 12.5 9.9 17c.4 0 .7 0 .8-.1z"
      style={{
        fill: props.fill,
        stroke: props.stroke,
        strokeWidth: props.strokeWidth,
        strokeLinecap: props.strokeLinecap,
      }}
      //default values
      // fill: "none",
      //   stroke: "#2f2f30",
      //   strokeWidth: 2,
      //   strokeLinecap: "round",
    />
  </svg>
)

export default Favourite